import { httpRequest } from 'http'
import { sendErrorNotification } from 'helpers/web_to_client'

import requestAccountInfo from 'state/actions/account'

import { MODERNIZATION_ANIMATION_TIMEOUT } from 'constants'

import SOUNDS from 'sounds'

export const COMMAND_CENTER_UPGRADE_REQUEST = 'command_center_upgrade/REQUEST'
export const COMMAND_CENTER_UPGRADE_SUCCESS = 'command_center_upgrade/SUCCESS'
export const COMMAND_CENTER_UPGRADE_ERROR = 'command_center_upgrade/ERROR'
export const COMMAND_CENTER_UPGRADE_OPEN_CONFIRMATION = 'command_center_upgrade/OPEN_CONFIRMATION'
export const COMMAND_CENTER_UPGRADE_CLOSE_CONFIRMATION = 'command_center_upgrade/CLOSE_CONFIRMATION'
export const COMMAND_CENTER_UPGRADE_SHOW_HIGHLIGHT = 'command_center_upgrade/SHOW_HIGHLIGHT'
export const COMMAND_CENTER_UPGRADE_HIDE_HIGHLIGHT = 'command_center_upgrade/HIDE_HIGHLIGHT'

let animationTimeout

export function startRequest() {
    return {
        type: COMMAND_CENTER_UPGRADE_REQUEST,
        payload: {},
    }
}

export function requestSuccess(data, buildingName) {
    const { command_center_level, industrial_resource_balance } = data
    return {
        type: COMMAND_CENTER_UPGRADE_SUCCESS,
        meta: {
            webToClient: {
                handler: 'buildingUpgraded',
                params: {
                    buildingName,
                    buildingLevel: command_center_level,
                },
            },
        },
        payload: {
            level: command_center_level,
            industrialResourceBalance: industrial_resource_balance,
        },
    }
}

export function requestError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: COMMAND_CENTER_UPGRADE_ERROR,
        payload: errorData,
    }
}

export function openConfirmation() {
    return {
        type: COMMAND_CENTER_UPGRADE_OPEN_CONFIRMATION,
        payload: {},
        meta: {
            webToClient: {
                handler: 'playSound',
                params: {
                    soundId: SOUNDS.MODERNIZATION_CLICK,
                },
            },
        },
    }
}

export function closeConfirmation() {
    clearTimeout(animationTimeout)
    return {
        type: COMMAND_CENTER_UPGRADE_CLOSE_CONFIRMATION,
        payload: {},
    }
}

export function showUpgradeHighlight() {
    return {
        type: COMMAND_CENTER_UPGRADE_SHOW_HIGHLIGHT,
        payload: {},
        meta: {
            webToClient: {
                handler: 'playSound',
                params: {
                    soundId: SOUNDS.MODERNIZATION_HOVER,
                },
            },
        },
    }
}

export function hideUpgradeHighlight() {
    return {
        type: COMMAND_CENTER_UPGRADE_HIDE_HIGHLIGHT,
        payload: {},
    }
}

export default function upgradeCommandCenter(level, name) {
    return async (dispatch, getState) => {
        if (getState().commandCenterUpgrade.submitting) {
            return
        }
        dispatch(startRequest())
        const url = '/game_api/command_center'
        httpRequest(url, 'PATCH', { level }).then(
            data => {
                animationTimeout = setTimeout(dispatch.bind(null, closeConfirmation()),MODERNIZATION_ANIMATION_TIMEOUT)
                dispatch(requestSuccess(data, name))
                dispatch(requestAccountInfo())
            },
            errorData => dispatch(requestError(errorData))
        )
    }
}



// WEBPACK FOOTER //
// ./state/actions/command_center_upgrade.js